var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 5,
    viewBox: "0 0 9 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.32291 0.47631C4.40155 0.394806 4.53212 0.394807 4.61076 0.47631L8.60669 4.61763C8.72922 4.74461 8.63923 4.9565 8.46277 4.9565H0.470902C0.294439 4.9565 0.204447 4.74461 0.326976 4.61763L4.32291 0.47631Z",
    fill: "#F97D09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedUpArrow);
export default __webpack_public_path__ + "static/media/SelectedUpArrow.169f09e9d9181bbae352ad6de0afba1b.svg";
export { ForwardRef as ReactComponent };